<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('course_agreement_form')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('course_agreement_form')" :isFilter="false" />
            </template>
            <div class="row mb-5 align-items-center" v-if="errorMessage">
                <div class="col-12">
                    <div class="row border p-2 d-flex justify-content-center align-items-center">
                        <div class="d-flex flex-column align-items-center">
                            <i class="ri-information-line" style="font-size: 100px">
                            </i>
                            <p>
                            {{$t('api.'+errorMessage)}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-5 align-items-center" v-if="data != null">
                <div class="col-12">
                    <div class="row border mb-2 p-2">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('student_number')">
                                {{ data.student_number }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('name_surname')">
                                {{ data.name }} {{ data.surname }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('semester_name')">
                                {{ data.academic_year + ' /'+ this.getLocaleText(data, 'semester_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('faculty_name')">
                                {{ this.getLocaleText(data, 'faculty_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('program')">
                                {{ this.getLocaleText(data, 'program_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('status')">
                                {{ this.getLocaleText(courseAgreement, 'status_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" v-if="courseAgreement">
                            <b-form-group :label="$t('reason')">
                                {{ courseAgreement?.reason}}
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="slots != null">
                <div v-if="courseAgreement!=null">
                    <div class="d-flex align-items-center justify-content-between">
                        <h6 class="mb-4">{{ $t('courses').toUpper() }}</h6>
                    </div>
                        <table class="table table-bordered table-responsive">
                            <tr>
                                <th>{{ $t('slot_type').toUpper() }}</th>
                                <th class="width-100">{{ $t('course_code').toUpper() }}</th>
                                <th>{{ $t('course_name').toUpper() + ' / ' + $t('elective_pool').toUpper() }}</th>
                                <th class="w-40">{{ $t('credit').toUpper() }}</th>
                                <th class="w-40">{{ $t('ects_credit').toUpper() }}</th>
                                <th class="w-40">{{ $t('semester').toUpper() }}</th>
                                <th class="w-40">{{ $t('grade').toUpper() }}</th>
                                <th class="w-40" >{{ $t('action').toUpper() }}</th>
                                <th style="width: 50%;text-align: center">{{ $t('selected_course').toUpper() }}</th>
                                <th>{{ $t('status').toUpper() }}</th>
                                <th style="text-align: center" v-if="['change_request','declined'].includes(courseAgreement.status)">{{ $t('cancel_reason').toUpper() }}</th>

                            </tr>

                            <tr v-for="slot in slots" v-bind:key="slot.id">
                                <td>{{ slot.slot_type }}</td>
                                <td>{{ slot.course ? slot.course.code : '' }}</td>
                                <td>{{
                                        slot.course ? getLocaleText(slot.course, 'name') : (slot.pool ? getLocaleText(slot.pool, 'name') : '')}}
                                </td>
                                <td>{{ slot.credit }}</td>
                                <td>{{ slot.ects_credit }}</td>
                                <td>{{ slot.semester }}</td>

                                <td><span v-if="slot.last_course">{{ slot.last_course.letter_grade }}</span>
                                </td>
                                <td  >
                                    <a v-if="isCheckedLetterGrade(slot)"
                                       role="button" class="ri-add-circle-line ri-2x" @click="addCourse(slot)"></a>
                                    <div v-else-if="!['approved'].includes(slot.selected_course?.status) && slot.selected_course">
                                        <a role="button" class="ri-delete-bin-line ri-2x"  @click="deleteSelectedCourse(slot.selected_course.id)" style="color: red"> </a>
                                    </div>
                                </td>
                                <td v-if="slot.selected_course">
                                    <div class="d-flex flex-row align-items-center">
                                        <div class="mr-5">
                                            <strong>{{$t('course_code')+ ': '}}</strong> {{slot.selected_course?.code}}   <strong>{{$t('course_name') + ': '}}</strong> {{slot.selected_course?.name}}<strong> {{$t('type')+ ': '}}</strong>{{slot.selected_course?.type}}
                                        </div>
                                    </div>
                                </td>
                                <td v-else>
                                </td>
                                <td>
                                    {{getLocaleText(slot.selected_course, 'status_name')}}
                                </td>
                                <td class="text-wrap" v-if="['change_request','declined'].includes(courseAgreement?.status)">
                                    {{slot.selected_course?.reason}}
                                </td>
                            </tr>
                        </table>


                    <div  class="d-flex justify-content-center align-items-center mt-5" v-if="['draft','change_request'].includes(courseAgreement?.status)">
                        <b-button variant="primary" @click="sendApplication">{{
                                $t('send_application').toUpper()
                            }}
                        </b-button>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center">
                    <b-button variant="primary" @click="startApplication">{{
                            $t('start_application').toUpper()
                        }}
                    </b-button>
                </div>
            </div>
            <CommonModal ref="courseModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" >
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('add_course') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <AddCourse v-if="formProcess==='add_course'" :courseId="courseId" @successCreate="successCreate"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import CommonModal from "@/components/elements/CommonModal";
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";
import AddCourse from "@/modules/CourseAgreementForm/pages/AddCourse.vue"
import CityService from "@/services/CityService";


export default {
    components: {
        AddCourse,
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,

    },
    data() {
        return {
            data: null,
            slots: null,
            formProcess: null,
            selectedCourses: {},
            courseId: null,
            courseAgreement: null,
            errorMessage: null,
        }
    },
    metaInfo() {
        return {
            title: this.$t("course_agreement_form")
        }
    },
    created() {
        this.loadData()
    },
    computed:{
      isActionButton(){
          if (Object.entries(this.slots).length > 0){
              let selectedCourse=[]
              let courseApproveLength=0
              Object.entries(this.slots).forEach(([key, value]) => {
                  if (value.selected_course){
                      selectedCourse.push(value)
                  }

              })
              selectedCourse.forEach(item=>{
                  if (item.selected_course.status==="approved"){
                      courseApproveLength+=1
                  }
              })
              return courseApproveLength === selectedCourse.length
          }else{
              return false
          }

      }
    },
    methods: {
        loadData(){
            CourseAgreementFormServices.getCourse()
                .then(response => {
                    this.data = response.data.data.student
                    this.slots = response.data.data.slots
                    this.courseAgreement=response.data.data.course_agreement
                }).catch(error => {
                    this.errorMessage=error.data.message
                    this.showErrors(error)
            });
        },
        addCourse(slot) {
            this.courseId=slot.id
            this.formProcess="add_course"
            this.$refs.courseModal.$refs.commonModal.show()
        },
        successCreate() {
            this.$refs.courseModal.$refs.commonModal.hide()
            this.formProcess=null
            this.loadData()
        },
        formClear(){
            this.formProcess=null
        },
       async startApplication(){
            try {
               const res =  await CourseAgreementFormServices.startApplication()
                this.$toast.success(this.$t("proccess_success"));
                this.loadData()
            }catch (error) {
                this.showErrors(error)
            }
        },
        isCheckedLetterGrade(slot) {
           return  !slot.selected_course && ['draft','change_request'].includes(this.courseAgreement.status)
        },

        deleteSelectedCourse(id) {
            this.deleteModal(() => {
                CourseAgreementFormServices.deleteSelectedCourse(id)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.loadData();
                    })
                    .catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    });
            });
        },
       async  sendApplication(){
             try {
                 const res =  await CourseAgreementFormServices.approvedApplication()
                 this.$toast.success(this.$t('api.' + res.data.message));
                 this.$router.push('/dashboard')
             }catch (error) {
                 this.showErrors(error)
             }
        }
    },
};
</script>
<style scoped>
.text-wrap {
    max-width: 200px;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    overflow-x: hidden;
    text-overflow: clip;
    padding: 8px;
}
</style>
